import { render, staticRenderFns } from "./RemoveCartItemOverlay.vue?vue&type=template&id=2fde4422&scoped=true&"
import script from "./RemoveCartItemOverlay.vue?vue&type=script&lang=ts&"
export * from "./RemoveCartItemOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveCartItemOverlay.vue?vue&type=style&index=0&id=2fde4422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde4422",
  null
  
)

export default component.exports